<template>
  <div id="container" ref="container">
    <div v-if="!sent" class="wrapper">
      <h2>reset password</h2>
      <div>
        <label for="email">enter your email</label>
        <input
          id="email"
          type="email"
          v-model="email"
          :placeholder="invalidEmail"
          :class="invalidEmail ? 'invalid' : ''"
          @click="invalidEmail = ''"
        />
      </div>
      <div id="buttons-raw">
        <base-button less @click="cancel">cancel</base-button>
        <base-button @click="submit" :isDisabled="sending || !!accountError"
          >send reset email</base-button
        >
      </div>
      <p class="timer-span" v-if="sending" style="text-align: center">
        sending...
      </p>
      <p
        id="con-error"
        v-if="accountError"
        style="margin-top: 4px; text-align: center"
      >
        {{ accountError }}
      </p>
    </div>
    <div v-else class="wrapper">
      <h4>reset link sent to <span>{{ email }}</span></h4>
      <h3><span @click="changeEmail">change</span> email or go to <router-link to="/login">login</router-link> page</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      email: '',
      invalidEmail: '',
      accountError: '',
      sending: false,
      sent: false
    };
  },
  methods: {
    async submit() {
      if (this.email === '') {
        this.invalidEmail = ' email cannot be empty';
        return;
      } else if (!this.email.includes('@')) {
        this.email = '';
        this.invalidEmail = ' invalid email';
        return;
      }

      try {
        this.sending = true;
        await this.$store.dispatch('user/resetPassword', this.email);
        this.sent = true;
        this.sending = false;
      } catch (error) {
        this.sending = false;
        this.accountError = error.message;
        if (error.message.includes('user-not-found')) {
          this.accountError = 'no such email registered';
        }
        const that = this;
        setTimeout(function () {
          that.accountError = '';
        }, 3000);
      }
    },
    cancel() {
      this.$router.replace('/');
    },
    changeEmail() {
      this.sent = false;
    }
  },
  mounted() {
    this.$refs.container.style.minHeight = `${window.innerHeight}px`;
  },
};
</script>

<style scoped>
#container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1em;
}

.wrapper {
  width: 90%;
}

.wrapper > div {
  margin: 10px 0;
}

h2 {
  text-align: center;
  margin-bottom: 50px;
}
h4, h3 {
  text-align: center;
}
h4 {
  color: #f08d8d;
}
h4 > span {
  user-select: none;
  color: blueviolet;
}

label {
  display: block;
  margin-bottom: 5px;
}

.timer-span {
  margin: 3px 0;
  color: #f08d8d;
  padding: 0;
}

#con-error {
  font-size: 0.8em;
  padding: 0;
  color: red;
  margin: 3px 0;
}

a,
h3 > span{
  text-decoration: none;
  color: blue;
  cursor: pointer;
}



input:focus {
  outline-color: blue;
}

.invalid {
  color: red;
  border-color: red;
}

#email {
  width: 100%;
  height: 25px;
  font-size: 1em;
  font-family: inherit;
  box-sizing: border-box;
}

#buttons-raw {
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px !important;
}

@media screen and (min-width: 390px) {
  .wrapper {
    width: unset;
  }

  #email {
    width: 350px;
    height: 30px;
  }
}

@media screen and (min-width: 700px) {
  #container {
    padding: 60px 0;
  }

  .wrapper {
    background-color: #f2f2f2;
    border-radius: 15px;
    padding: 40px;
  }
}
</style>
